import { useState } from "react";
import axios, { AxiosProgressEvent, CancelTokenSource } from "axios";
import { v4 as uuid } from "uuid";
import { UploadNodeState } from "./UploadFileNode"; // 导入你的枚举值
import {
  IAliOssToken,
  IAliyunRequest,
  getUploadToken,
} from "@/services/fileUpload/fileUpload";
import http from "@/utils/http";

interface UseFileUploadResult {
  progress: number | string;
  uploadState: UploadNodeState;
  cancelUpload: () => void;
  hanldeUploadFile: (file: File, data: IAliyunRequest) => void;
  id: string;
}

function useFileUpload(): UseFileUploadResult {
  const [progress, setProgress] = useState<number | string>(0);
  const [uploadState, setUploadState] = useState<UploadNodeState>("queued");
  const [cancelTokenSource, setCancelTokenSource] =
    useState<CancelTokenSource>(null);

  const [id, setId] = useState<string>(null);

  const getMaterialState = async (id: string) => {
    const result = await http.get(`/api/v1/space/material/${id}`, {
      timeout: 3000,
    });
    return result.data.material.status;
  };

  const hanldeUploadFile = async (file: File, data: IAliyunRequest) => {
    const aliyunToken = await getUploadToken({
      size: file.size,
      filename: data.filename,
      floderId: data.floderId,
      projectId: data.projectId,
    });
    uploadFile(aliyunToken, file);
  };

  const uploadFile = async (token: IAliOssToken, file: File): Promise<void> => {
    const newFormData = new FormData();
    const source = axios.CancelToken.source();
    setCancelTokenSource(source);

    newFormData.append("key", `${token.dir}${uuid()}-${file.name}`);
    newFormData.append("callback", token.callback);
    newFormData.append("OSSAccessKeyId", token.accessid);
    newFormData.append("policy", token.policy);
    newFormData.append("Signature", token.signature);
    newFormData.append("expire", token.expire);
    newFormData.append("success_action_status", "200");
    newFormData.append("Content-Disposition", `attachment`);
    newFormData.append("file", file);

    try {
      setUploadState("uploading");
      const response = await axios.post(token.host, newFormData, {
        timeout: 100000000,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (event: AxiosProgressEvent) => {
          if (event.total) {
            const percentComplete = (
              (event.loaded / event.total) *
              100
            ).toFixed(2);
            setProgress(percentComplete);
          }
        },
        cancelToken: source.token,
      });

      if (response.status === 200) {
        setProgress(100);
        const timer = setInterval(async () => {
          const status = await getMaterialState(response.data.data.material_id || response.data.data.id);
          if (status === 3 || status === 4) {
            setId(response.data.data.material_id || response.data.data.id);
            clearInterval(timer);
            if (status === 3) {
              setUploadState("error");
            }

            if (status === 4) {
              setUploadState("success");
            }
          }
          if (status == 2) {
          }
        }, 3000);
      } else {
        setUploadState("error");
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Upload canceled");
        setUploadState("cancelled");
      } else {
        console.error("Upload failed:", error);
        setUploadState("error");
      }
    }
  };

  const cancelUpload = () => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Upload canceled ！！！");
      setUploadState("cancelled");
    }
  };

  return { progress, uploadState, cancelUpload, hanldeUploadFile, id };
}

export default useFileUpload;

// | "queued"
// | "uploading"
// | "success"
// | "error"
// | "cancelled";
